// 投注
const _import = name => {
  return resolve => require([`../../views/${name}`], resolve)
}

const BetChild = {
  path: '/bet',
  component: _import('betting'),
  children: [
    {
      path: '',
      meta: {
        navShow: false,
        titleHide: true,
        // requireAuth: true,
        title: '投注'
      },
      name: 'Bet',
      component: resolve => require(['@/common/components/betting/bet1/'], resolve)
    },
    {
      path: 'record',
      meta: {
        navShow: false,
        titleHide: true,
        // requireAuth: true,
        title: '开奖记录'
      },
      name: 'Record',
      component: resolve => require(['@/common/components/betting/record1/'], resolve)
    },
    {
      path: 'my-record',
      meta: {
        navShow: false,
        titleHide: true,
        requireAuth: true,
        title: '我的投注记录'
      },
      name: 'myRecord',
      component: resolve => require(['@/common/components/betting/my-record1/'], resolve)
    },
    // {
    //   path: 'trend-chart',
    //   meta: {
    //     navShow: false,
    //     titleHide: true,
    //     // requireAuth: true,
    //     title: '走势图'
    //   },
    //   name: 'trendChart',
    //   component: resolve => require(['@/common/components/betting/trend-chart/'], resolve)
    // },
  ]
}

export default BetChild



// WEBPACK FOOTER //
// ./src/pages/build922/router/module/Betting.js